export default "__VITE_ASSET__T2i8ON$Rt7w_yNtNiyMeEg__";